import { notification } from "antd";
import moment from "moment";
import {
  GET_SUPPLIERS,
  GET_SUPPLIER_BY_ID,
  SET_SUPPLIER_TO_NULL,
} from "./types";

import { AuthorizedApiService } from "../../../services/apiServices";
import { NavigationPath } from "../../../helpers/constants";

export const registerSupplier = (supplier) => async (dispatch) => {
  try {
    AuthorizedApiService.post("supplier", supplier)
      .then((res) => {
        console.log(res);
        if (res.status !== 201) {
          notification.error({
            message: "Invalid Register!",
          });
          return;
        }

        notification.success({
          message: "Supplier registered!",
        });
        window.location = NavigationPath.SUPPLIERS_ROUTE;
      })
      .catch((err) =>
        notification.error({
          message: "Invalid Register!",
        })
      );
  } catch (err) {
    console.log(err);
  }
};

export const getSuppliers = () => async (dispatch) => {
  try {
    AuthorizedApiService.get("supplier")
      .then((res) => {
        const { status, data } = res;
        if (
          status !== 200 &&
          window.location.pathname === NavigationPath.SUPPLIERS_ROUTE
        ) {
          notification.error({
            message: "Something went wrong,can not get suppliers",
          });
          return;
        }
        const suppliers = data.map((supplier) => ({
          key: supplier.id,
          kompanija: supplier.companyName,
          datum: moment(supplier.updatedAt).format("YYYY-MM-DD HH:mm:ss"),
        }));

        dispatch({
          type: GET_SUPPLIERS,
          payload: suppliers,
        });
      })
      .catch(
        (err) =>
          window.location.pathname === NavigationPath.SUPPLIERS_ROUTE &&
          notification.error({
            message: "Something went wrong,can not get suppliers",
          })
      );
  } catch (err) {
    console.log(err);
  }
};

export const getSupplierById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: SET_SUPPLIER_TO_NULL,
    });
    AuthorizedApiService.get(`supplier/${id}`)
      .then((res) => {
        const { status, data } = res;
        if (status !== 200) {
          notification.error({
            message: "Something went wrong!",
          });
          return;
        }
        dispatch({
          type: GET_SUPPLIER_BY_ID,
          payload: data,
        });
      })
      .catch((err) => {
        notification.error({
          message: "Something went wrong!",
        });
      });
  } catch (error) {
    console.log(error);
  }
};

export const updateSupplierById = (supplierToEdit, id) => async (dispatch) => {
  try {
    AuthorizedApiService.put(`supplier/${id}`, supplierToEdit)
      .then((res) => {
        const { status, data } = res;
        console.log(res);
        if (status !== 200) {
          notification.error({
            message: "Update error!",
          });
          return;
        }
        notification.success({
          message: "Update success!",
        });
        window.location = NavigationPath.SUPPLIERS_ROUTE;
      })
      .catch((err) => {
        notification.error({
          message: "Update error!",
        });
      });
  } catch (error) {
    console.log(error);
  }
};

export const deleteSupplier = (ids) => async (dispatch) => {
  try {
    AuthorizedApiService.delete("supplier", {
      data: { ids },
    })
      .then((res) => {
        if (res.status !== 200) {
          notification.error({
            message: "Something went wrong!",
          });
          return;
        }
        notification.success({
          message:
            ids.length === 1 ? "Supplier deleted!" : "Suppliers deleted!",
        });
        dispatch(getSuppliers());
      })
      .catch((err) => {
        notification.error({
          message: "Something went wrong!",
        });
      });
  } catch (error) {
    console.log(error);
  }
};
